// extracted by mini-css-extract-plugin
module.exports = {"outerNavLink":"ComboNavLink_outerNavLink__3wbXU","subText":"ComboNavLink_subText__cV5Ry"};